import React, { useEffect, useRef, useState } from "react";
import { 
    Grid, 
    List, 
    ListItem, 
    ListItemText, 
    Box, 
    Typography, 
    Container, 
    CircularProgress, 
    Alert, 
    TextField, 
    Button,
    FormControl,
    FormLabel,
    Stack
} from "@mui/material";
import { ChromePicker, CirclePicker } from 'react-color';
import { getTemplateGroups, addTemplateGroup } from "../../api/axios";
import { useTranslation } from "react-i18next";
const TemplateGroups = () => {
    const { t } = useTranslation("global");
    const [templateGroups, setTemplateGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [newGroupName, setNewGroupName] = useState("");
    const [adding, setAdding] = useState(false);
    const [addError, setAddError] = useState(null);
    const [showColorPicker, setShowColorPicker] = useState(false);
    const [color, setColor] = useState("#ff00ff");
    const [customColors, setCustomColors] = useState([]);
    const pickerRef = useRef(null);

    const handleChange = (newValue) => {
    setColor(newValue)
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        console.log('Clicked outside the ChromePicker');
        setShowColorPicker(false); // or trigger your blur logic
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const groups = await getTemplateGroups();
                setTemplateGroups(groups);
                const colorCount = groups.reduce((acc, item) => {
                  const color = item.color ? item.color : "#001d4f";
                  if (color) { // Only count non-null/undefined colors
                    acc[color] = (acc[color] || 0) + 1;
                  }
                  return acc;
                }, {});
                setCustomColors(Object.entries(colorCount)
                .sort((a, b) => b[1] - a[1]) // sort by count descending
                //.slice(0, 6) // top 6
                .map(([color]) => color))
            } catch (err) {
                setError(t("templateGroups.errorFetching"));
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [t]);

    const handleAddGroup = async () => {
        if (!newGroupName.trim()) return;
        setAdding(true);
        setAddError(null);
    
        try {
            const params = new URLSearchParams();
            params.append("name", newGroupName);
            params.append("color", color)
            await addTemplateGroup(params); // API poziv
    
            window.location.reload(); // Osvežavanje stranice nakon uspešnog dodavanja
        } catch (err) {
            setAddError(t("templateGroups.errorAdding"));
        } finally {
            setAdding(false);
        }
    };

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    mt: 4,
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    backgroundColor: "#f9f9f9",
                }}
            >
                <Typography variant="h4" align="center" gutterBottom>
                    {t("templateGroups.templateGroups")}
                </Typography>

                <Grid container spacing={2} mb={2}>
                    <Grid item xs={12}>
                        <TextField
                                        fullWidth
                                        label={t("templateGroups.newGroup")}
                                        variant="outlined"
                                        value={newGroupName}
                                        onChange={(e) => setNewGroupName(e.target.value)}
                                    />
                                    
                    </Grid>
                                <Grid item xs={12} sx={{display: "flex", alignItems: "center", gap: 2}}>
                                    
                                    
                                    <Typography>{t("templateGroups.selectColor")}</Typography>
                                    <div style={{ position: 'relative', display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        
                                        <div 
                                            style={{
                                                width: '36px',
                                                height: '36px',
                                                borderRadius: '50%',
                                                background: color,
                                                cursor: 'pointer',
                                                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                                            }}
                                            onClick={() => setShowColorPicker(!showColorPicker)}
                                        />
                                        {showColorPicker && (
                                            <div ref={pickerRef} style={{ position: 'absolute', zIndex: 2, top: 50}}>
                                                <ChromePicker
                                                    disableAlpha="true"
                                                    color={color}
                                                    onChangeComplete={(color) => {
                                                        setColor(color.hex);
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sx={{display: "flex", flexDirection:"column", alignItems:"start", gap: 2}}>
                                    <Typography>{t("templateGroups.mostUsed")}</Typography>
                                    <CirclePicker width="100%" colors={customColors} onChange={(color) => {setColor(color.hex)}}styles={{
                                        default: {
                                        circle: {
                                            boxShadow: '0 0 6px rgba(0, 0, 0, 0.4)',
                                        }
                                        }
                                    }} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        onClick={handleAddGroup}
                                        disabled={adding}
                                    >
                                        {t("templateGroups.addButton")}
                                    </Button>
                                </Grid>
                </Grid>
                {loading && <CircularProgress sx={{ display: "block", mx: "auto", mt: 2 }} />}
                {error && <Alert severity="error">{error}</Alert>}

                {!loading && !error && (
                    <List>
                        

                        {addError && <Alert severity="error" sx={{ mt: 2 }}>{addError}</Alert>}


                        {templateGroups.map((group, index) => (
                            <ListItem key={index} divider>
                                <ListItemText primary={group.name}/>
                                <div style={{
                                                width: '36px',
                                                height: '36px',
                                                borderRadius: '50%',
                                                background: group.color || "#001d4f" ,
                                                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                                            }} />
                            </ListItem>
                        ))}

                        
                    </List>
                )}
            </Box>
        </Container>
    );
};

export default TemplateGroups;
